/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：639
 */

module.exports = function (e, t, n) {
  if (!(e instanceof t)) {
    throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation")
  }
  return e
}
